import { useApplicationField } from '../useApplicationField';

// ─── Third Party Compensation ─────────────────────────────────────────────────

export const useBorrowerThirdPartyName = () =>
    useApplicationField(
        (d) => d.information?.borrower?.finalizeThirdPartyName ?? '',
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information?.borrower, finalizeThirdPartyName: v } } })
    );

export const useBorrowerThirdPartyExpectation = () =>
    useApplicationField(
        (d) => d.information?.borrower?.finalizeThirdPartyClaim ?? null,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information?.borrower, finalizeThirdPartyClaim: v } } })
    );
